import { render, staticRenderFns } from "./SuppliersQuickAdd.vue?vue&type=template&id=f27cb1fc&"
import script from "./SuppliersQuickAdd.vue?vue&type=script&lang=js&"
export * from "./SuppliersQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports